import React from 'react';

import Carousel from 'antd/es/carousel';
import UpArrowIcon from '../Icons/up_arrow.svg';
import { classNames } from './pureHelpers';

const CarouselWithIndicators = ({ children, width = '4rem', ...props }: $TSFixMe) => (
  <div className='carousel-indicators mx-auto' style={{ width }}>
    <Carousel {...props} className='mx-auto' prevArrow={<LeftArrow />} nextArrow={<RightArrow />}>
      {children}
    </Carousel>
  </div>
);

const LeftArrow = ({ className: arrowClassName, currentSlide, slideCount, ...restArrowProps }: $TSFixMe) => {
  const newRestArrowProps = { ...restArrowProps, style: null };

  return (
    <span {...newRestArrowProps} className={classNames(Number(currentSlide) === 0 ? 'disabled' : '', arrowClassName)}>
      <UpArrowIcon />
    </span>
  );
};
const RightArrow = ({ className: arrowClassName, currentSlide, slideCount, ...restArrowProps }: $TSFixMe) => {
  const newRestArrowProps = { ...restArrowProps, style: null };
  return (
    <span
      {...newRestArrowProps}
      className={classNames(Number(currentSlide) === Number(slideCount) ? 'disabled' : '', arrowClassName)}>
      <UpArrowIcon />
    </span>
  );
};

export default CarouselWithIndicators;
